import type React from 'react'
import { conformToMask } from 'react-text-mask'
import { phoneInputMask } from 'utils/masks'
import { cleanPhone } from 'utils/cleanPhone'

/** 79991234567 -> +7 (999) 123-45-67 */
export const formatPhone = (phone: string): string => {
  return phone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 ($2) $3-$4-$5')
}

/** A pasted phone in any of 7…, 8… or 9… forms, conformed to the phone mask */
export const formatPhoneOnPaste = (e: React.ClipboardEvent) => {
  e.preventDefault()
  const value = cleanPhone(e.clipboardData.getData('Text'))
  if (value[0] === '7') {
    return conformToMask('+' + value, phoneInputMask).conformedValue
  }
  if (value[0] === '8') {
    return conformToMask('+7' + value.slice(1), phoneInputMask).conformedValue
  }
  return conformToMask(value, phoneInputMask).conformedValue
}
